import React from "react";
import { Field, Panel, StateChip } from "@/components/ldc01/Ldc01Ui";
import { NP } from "@/lib/ldc01";

const counts = (src) => (src && typeof src === "object" && !Array.isArray(src)
  ? Object.entries(src).filter(([, v]) => typeof v === "number") : []);

export function ResultStep({ resultJob, recon }) {
  if (!resultJob) {
    return (
      <Panel title="Results" testId="ldc01-result-step">
        <p className="text-sm text-zinc-500 italic" data-testid="ldc01-result-empty">No execute or restore job recorded on the server.</p>
      </Panel>
    );
  }
  const rep = resultJob.report || {};
  const failed = resultJob.status !== "succeeded";
  const rows = counts(rep.target_counts);
  return (
    <div className="space-y-5" data-testid="ldc01-result-step">
      <Panel title="Results" subtitle="Read-only server record.">
        <Field label="Job" value={`${resultJob.kind} · ${resultJob.id}`} mono testId="ldc01-result-job" />
        <Field label="Job status" value={<StateChip state={resultJob.status === "succeeded" ? "PASS" : resultJob.status === "running" ? "PENDING" : "FAIL"} testId="ldc01-result-status" />} />
        <Field label="Reconciliation outcome" value={rep.result || NP} mono muted={!rep.result} testId="ldc01-result-outcome" />
        <Field label="Audit reference" value={rep.run_id || NP} mono muted={!rep.run_id} testId="ldc01-result-audit-ref" />
        <Field label="Recovery required" value={rep.recovery_required ? "YES — all cleanup jobs blocked" : rep.recovery_required === false ? "No" : NP}
          muted={rep.recovery_required == null} testId="ldc01-result-recovery" />
        {failed && rep.result && <Field label="Error" value={rep.result} mono testId="ldc01-result-error-text" />}
        <Field label="Records archived (server total)" value={typeof rep.archived === "number" ? rep.archived : NP} mono
          muted={typeof rep.archived !== "number"} testId="ldc01-result-archived" />
      </Panel>
      <Panel title="Post-cleanup reconciliation" subtitle="Server-computed per collection: expected vs archived vs targets still present.">
        {recon?.per_collection?.length ? (
          <div className="overflow-x-auto">
            <div className="mb-2"><StateChip state={recon.state === "RECONCILED" || recon.state === "RESTORED" ? "PASS" : recon.state === "PENDING" ? "PENDING" : "FAIL"} testId="ldc01-recon-state" /> <span className="text-xs font-mono text-zinc-400 ml-2">{recon.state}</span></div>
            <table className="w-full text-sm" data-testid="ldc01-recon-table">
              <thead><tr className="text-left overline"><th className="py-2">Collection</th><th className="py-2 text-right">Expected</th><th className="py-2 text-right">Archived</th><th className="py-2 text-right">Remaining</th></tr></thead>
              <tbody>{recon.per_collection.map((r) => (
                <tr key={r.collection} className="border-t border-[var(--border)]"><td className="py-2 font-mono text-zinc-200">{r.collection}</td>
                  <td className="py-2 text-right font-mono">{r.expected}</td><td className="py-2 text-right font-mono">{r.archived}</td><td className="py-2 text-right font-mono">{r.remaining_targets}</td></tr>
              ))}</tbody>
            </table>
          </div>
        ) : <p className="text-sm text-zinc-500 italic" data-testid="ldc01-recon-np">{recon?.reason || NP}</p>}
      </Panel>
      <Panel title="Per-collection counts" subtitle="Pre-execution target counts recorded by this job.">
        {rows.length ? (
          <table className="w-full text-sm" data-testid="ldc01-result-counts">
            <tbody>{rows.map(([k, v]) => (
              <tr key={k} className="border-t border-[var(--border)] first:border-0"><td className="py-2 font-mono text-zinc-200">{k}</td><td className="py-2 text-right font-mono text-white">{v}</td></tr>
            ))}</tbody>
          </table>
        ) : <p className="text-sm text-zinc-500 italic" data-testid="ldc01-result-counts-np">{NP}</p>}
      </Panel>
    </div>
  );
}
